(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mc-heritage"] && !Shopify.designMode) return;
  try {
    
(function () {
  var fan = document.getElementById('mcxHerFan');
  if (!fan) return;
  var cards = [].slice.call(fan.querySelectorAll('.mcx-her__card'));
  var cap = document.getElementById('mcxHerCap');
  var n = cards.length;
  var HALF = 3;
  var VISIBLE = Math.min(7, n);
  var center = 3; // Paul opens in the middle
  var busy = false;

  var SLOTS = [
    { rot: -21, scale: 0.7756, x: -30, y: 7.3, z: 1 },
    { rot: -14, scale: 0.8498, x: -22, y: 4.0, z: 2 },
    { rot: -7,  scale: 0.9346, x: -11, y: 1.3, z: 3 },
    { rot: 0,   scale: 1.0,    x: 0,   y: 0.0, z: 10 },
    { rot: 7,   scale: 0.9346, x: 11,  y: 1.3, z: 3 },
    { rot: 14,  scale: 0.8498, x: 22,  y: 4.0, z: 2 },
    { rot: 21,  scale: 0.7756, x: 30,  y: 7.3, z: 1 }
  ];

  function mult() {
    var w = window.innerWidth;
    if (w < 480) return 0.26;
    if (w < 640) return 0.36;
    if (w < 768) return 0.48;
    if (w < 1024) return 0.72;
    return 1;
  }

  function render() {
    var m = mult();
    var slotOf = {};
    for (var s = 0; s < VISIBLE; s++) {
      slotOf[((center + s - HALF) % n + n) % n] = s;
    }
    cards.forEach(function (card, i) {
      var s = slotOf[i];
      if (s !== undefined) {
        var p = SLOTS[s];
        card.style.opacity = '1';
        card.style.zIndex = p.z;
        card.style.transform = 'translate(' + (p.x * m) + 'rem,' + p.y + 'rem) rotate(' + p.rot + 'deg) scale(' + p.scale + ')';
        card.style.pointerEvents = 'auto';
      } else {
        var rel = ((i - center) % n + n) % n;
        var side = rel > n / 2 ? -1 : 1;
        card.style.opacity = '0';
        card.style.zIndex = 0;
        card.style.transform = 'translate(' + (side * 38 * m) + 'rem,2rem) rotate(' + (side * 26) + 'deg) scale(0.45)';
        card.style.pointerEvents = 'none';
      }
    });
    cap.textContent = cards[center].getAttribute('data-cap');
  }

  function cycle(d) {
    if (busy) return;
    busy = true;
    setTimeout(function () { busy = false; }, 480);
    center = ((center + d) % n + n) % n;
    render();
  }

  document.getElementById('mcxHerPrev').addEventListener('click', function () { cycle(-1); });
  document.getElementById('mcxHerNext').addEventListener('click', function () { cycle(1); });

  var tx = null;
  fan.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
  fan.addEventListener('touchend', function (e) {
    if (tx === null) return;
    var dx = e.changedTouches[0].clientX - tx;
    if (Math.abs(dx) > 40) cycle(dx < 0 ? 1 : -1);
    tx = null;
  }, { passive: true });

  var rt = null;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(render, 150);
  });

  render();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-hero-cinema"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-mcx-cin]');
  if (!root) return;
  var scenes = [].slice.call(root.querySelectorAll('[data-cin-scene]'));
  var panels = [].slice.call(root.querySelectorAll('[data-cin-panel]'));
  var btns = [].slice.call(root.querySelectorAll('[data-cin-btn]'));
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var active = 0;
  var busy = false;

  function setH() {
    var top = root.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
    root.style.setProperty('--cin-h', 'calc(100svh - ' + Math.max(0, Math.round(top)) + 'px)');
  }
  setH();
  window.addEventListener('resize', setH);
  window.addEventListener('load', setH);

  function portraitMode() {
    return window.matchMedia('(max-aspect-ratio: 4/5)').matches;
  }

  function ensureVideo(i) {
    if (reduced) return null;
    var scene = scenes[i];
    var src;
    if (portraitMode()) {
      src = scene.getAttribute('data-video-portrait') || scene.getAttribute('data-video-landscape');
    } else {
      src = scene.getAttribute('data-video-landscape');
    }
    if (!src) return null;
    var v = scene.querySelector('video');
    if (!v) {
      v = document.createElement('video');
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('muted', '');
      v.preload = 'auto';
      scene.appendChild(v);
    }
    if (v.getAttribute('data-current-src') !== src) {
      v.src = src;
      v.setAttribute('data-current-src', src);
    }
    return v;
  }

  function activate(i, instant) {
    active = i;
    scenes.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
    panels.forEach(function (p, k) {
      var on = k === i;
      p.classList.toggle('is-on', on);
      if (on) { p.removeAttribute('inert'); } else { p.setAttribute('inert', ''); }

    });
    btns.forEach(function (b, k) {
      b.classList.toggle('is-on', k === i);
      b.setAttribute('aria-current', k === i ? 'true' : 'false');
    });
    var v = ensureVideo(i);
    if (v) {
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () {});
    }
    scenes.forEach(function (s, k) {
      if (k === i) return;
      var ov = s.querySelector('video');
      if (ov) setTimeout(function () { ov.pause(); }, instant ? 0 : 1050);
    });
  }

  btns.forEach(function (b, i) {
    b.addEventListener('click', function () {
      if (busy || i === active) return;
      busy = true;
      setTimeout(function () { busy = false; }, 1000);
      activate(i);
    });
  });

  activate(0, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-product-snapshot"] && !Shopify.designMode) return;
  try {
    
(function () {
  var host = document.getElementById('mcxSnapAcc');
  if (!host || !window.MCX_SNAP) return;
  var D = window.MCX_SNAP;

  var IC = {
    layers: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>',
    feel: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/></svg>',
    who: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
    ruler: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21.3 8.7 8.7 21.3a1 1 0 0 1-1.4 0l-4.6-4.6a1 1 0 0 1 0-1.4L15.3 2.7a1 1 0 0 1 1.4 0l4.6 4.6a1 1 0 0 1 0 1.4z"/><path d="m7.5 10.5 2 2M10.5 7.5l2 2M13.5 4.5l2 2M4.5 13.5l2 2"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="9 12 11.5 14.5 16 10"/></svg>',
    chev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>'
  };
  var LAYER_IC = {
    spring: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"><path d="M4 6h16M4 10h16M4 14h16M4 18h16"/><path d="M6 6c2 1.3 2 2.7 0 4s-2 2.7 0 4 2 2.7 0 4"/><path d="M12 6c2 1.3 2 2.7 0 4s-2 2.7 0 4 2 2.7 0 4"/><path d="M18 6c2 1.3 2 2.7 0 4s-2 2.7 0 4 2 2.7 0 4"/></svg>',
    foam: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M3 15c0-4 4-7 9-7s9 3 9 7"/><path d="M3 15h18v3H3z"/><path d="M8 11c1-1.4 2.6-2 4-2s3 .6 4 2"/></svg>',
    hd: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="9" rx="2"/><path d="M3 12h18M7 8v9M12 8v9M17 8v9"/></svg>',
    cool: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20M4.2 7l15.6 10M19.8 7 4.2 17"/><path d="m9 4 3 2 3-2M9 20l3-2 3 2"/></svg>',
    latex: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s7-5 7-10a7 7 0 1 0-14 0c0 5 7 10 7 10z"/><path d="M12 12a3 3 0 0 0 0-6"/></svg>'
  };
  function pickIcon(t) {
    var s = (t || '').toLowerCase();
    if (/spring|coil/.test(s)) return LAYER_IC.spring;
    if (/cool|gel|ice|breath|knit|cover/.test(s)) return LAYER_IC.cool;
    if (/latex/.test(s)) return LAYER_IC.latex;
    if (/hd|high density|base|edge|firm/.test(s)) return LAYER_IC.hd;
    return LAYER_IC.foam;
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  var STEPS = ['Plush', 'Medium Plush', 'Medium', 'Medium Firm', 'Firm'];
  var panels = [];

  if (D.layers && D.layers.length) {
    panels.push({
      ic: IC.layers, t: "What's Inside This Mattress?", s: 'Quality materials designed for better sleep',
      html: '<div class="snap-layers">' + D.layers.slice(0, 4).map(function (l) {
        return '<div class="snap-layer"><div class="ic">' + pickIcon(l.title) + '</div><h4>' + esc(l.title) + '</h4><p>' + esc(l.body) + '</p></div>';
      }).join('') + '</div>'
    });
  }

  if (D.feel) {
    var idx = STEPS.indexOf(D.feel.level);
    var pct = idx < 0 ? 50 : (idx / (STEPS.length - 1)) * 100;
    panels.push({
      ic: IC.feel, t: 'How it Feels', s: D.feel.summary,
      html: '<div class="snap-feel"><div>' + D.feel.body.map(function (p) { return '<p>' + esc(p) + '</p>'; }).join('') + '</div>' +
        '<div><div class="snap-scale-label">Feel Level</div><div class="snap-scale">' +
        STEPS.map(function (_, i) { return '<span class="snap-tick" style="left:' + (i / (STEPS.length - 1)) * 100 + '%"></span>'; }).join('') +
        '<span class="snap-dot" style="left:' + pct + '%"></span></div>' +
        '<div class="snap-scale-names">' + STEPS.map(function (n) { return '<span class="' + (n === D.feel.level ? 'on' : '') + '">' + n + '</span>'; }).join('') + '</div></div></div>'
    });
  }

  if (D.who && D.who.length) {
    panels.push({
      ic: IC.who, t: 'Who is it Best For?', s: D.whoSummary || '',
      html: '<div class="snap-who">' + D.who.map(function (w) { return '<div>' + IC.check + '<span>' + esc(w) + '</span></div>'; }).join('') + '</div>'
    });
  }

  if (D.sizes && D.sizes.length) {
    var anyH = D.sizes.some(function (s) { return s.height; });
    var anyW = D.sizes.some(function (s) { return s.weight; });
    panels.push({
      ic: IC.ruler, t: 'Dimensions & Weight', s: 'Detailed mattress measurements',
      html: '<div class="snap-tablebox"><table class="snap-table"><thead><tr><th>Size</th><th>Length</th><th>Width</th>' +
        (anyH ? '<th>Height</th>' : '') + (anyW ? '<th>Weight</th>' : '') + '</tr></thead><tbody>' +
        D.sizes.map(function (s) {
          return '<tr><td>' + esc(s.name) + '</td><td>' + esc(s.length) + '</td><td>' + esc(s.width) + '</td>' +
            (anyH ? '<td>' + esc(s.height || 'Not listed') + '</td>' : '') +
            (anyW ? '<td>' + esc(s.weight || 'Not listed') + '</td>' : '') + '</tr>';
        }).join('') + '</tbody></table></div>' + (D.sizeNote ? '<p class="snap-note">' + esc(D.sizeNote) + '</p>' : '')
    });
  }

  host.innerHTML = panels.map(function (p, i) {
    return '<div class="snap-item" data-i="' + i + '">' +
      '<button class="snap-head" type="button" aria-expanded="false">' +
        '<span class="snap-ic">' + p.ic + '</span>' +
        '<span class="snap-txt"><span class="snap-t">' + p.t + '</span>' + (p.s ? '<span class="snap-s">' + esc(p.s) + '</span>' : '') + '</span>' +
        '<span class="snap-chev">' + IC.chev + '</span>' +
      '</button>' +
      '<div class="snap-body"><div class="snap-inner">' + p.html + '</div></div>' +
    '</div>';
  }).join('');

  host.addEventListener('click', function (e) {
    var btn = e.target.closest('.snap-head');
    if (!btn) return;
    var item = btn.closest('.snap-item');
    var body = item.querySelector('.snap-body');
    var open = item.classList.toggle('open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    body.style.maxHeight = open ? body.scrollHeight + 'px' : '0';
  });

  // The VSL builds the page in JS, so wait for the gallery/buy box grid then move this
  // section directly beneath it, matching the approved mockup placement.
  var moved = false;
  function relocate() {
    if (moved) return true;
    var pdp = document.querySelector('.wrap.pdp') || document.querySelector('.pdp');
    var sec = document.querySelector('.mc-product-snapshot-wrap') || document.querySelector('.mcx-snap');
    if (!pdp || !sec) return false;
    if (pdp.nextElementSibling === sec) { moved = true; return true; }
    pdp.insertAdjacentElement('afterend', sec);
    moved = true;
    return true;
  }
  if (!relocate()) {
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (relocate() || tries > 60) clearInterval(iv);
    }, 250);
  }

  window.addEventListener('resize', function () {
    host.querySelectorAll('.snap-item.open .snap-body').forEach(function (b) { b.style.maxHeight = b.scrollHeight + 'px'; });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-reviews-wall"] && !Shopify.designMode) return;
  try {
    
(function () {
  var grid = document.getElementById('mcxRwGrid');
  var pager = document.getElementById('mcxRwPager');
  if (!grid || !pager || !window.MCX_RW_DATA) return;
  // A page can scope this wall to one range by setting window.MCX_RW_FILTER
  // to a list of product handles before this script runs.
  var ALL = window.MCX_RW_DATA;
  var F = window.MCX_RW_FILTER;
  var DATA = (F && F.length) ? ALL.filter(function (r) { return F.indexOf(r.p) > -1; }) : ALL;
  if (!DATA.length) DATA = ALL;
  var SIZE = 9;
  var pages = Math.ceil(DATA.length / SIZE);
  var cur = 0;

  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function initials(n) {
    var p = n.trim().split(/\s+/);
    return ((p[0] || '')[0] || '') + ((p[1] || '')[0] || '');
  }

  function card(r) {
    return '<article class="mcx-rw__card">' +
      '<div class="mcx-rw__stars" aria-label="5 out of 5 stars">&#9733;&#9733;&#9733;&#9733;&#9733;</div>' +
      (r.t ? '<h3 class="mcx-rw__ct">' + esc(r.t) + '</h3>' : '') +
      '<p class="mcx-rw__cb">' + esc(r.c) + '</p>' +
      '<div class="mcx-rw__foot">' +
        '<span class="mcx-rw__av">' + esc(initials(r.n).toUpperCase()) + '</span>' +
        '<span><span class="mcx-rw__nm">' + esc(r.n) + '</span><br>' +
        '<span class="mcx-rw__vb">' + (r.v ? 'Verified buyer' : 'Reviewer') + ' &middot; ' + esc(r.d) + '</span></span>' +
      '</div></article>';
  }

  function pageNumbers() {
    var out = [];
    for (var i = 0; i < pages; i++) {
      if (i === 0 || i === pages - 1 || Math.abs(i - cur) <= 1) out.push(i);
      else if (out[out.length - 1] !== 'gap') out.push('gap');
    }
    return out;
  }

  function colCount() {
    var w = window.innerWidth;
    return w > 900 ? 3 : (w > 620 ? 2 : 1);
  }

  function render(scroll) {
    var n = colCount();
    var cols = [], heights = [];
    for (var k = 0; k < n; k++) { cols.push([]); heights.push(0); }
    DATA.slice(cur * SIZE, cur * SIZE + SIZE).forEach(function (r) {
      var est = 130 + Math.ceil(((r.t || '').length + (r.c || '').length) / 38) * 22;
      var min = 0;
      for (var i = 1; i < n; i++) if (heights[i] < heights[min]) min = i;
      cols[min].push(card(r));
      heights[min] += est;
    });
    grid.innerHTML = cols.map(function (c) { return '<div class="mcx-rw__col">' + c.join('') + '</div>'; }).join('');
    var html = '<button type="button" data-go="prev"' + (cur === 0 ? ' disabled' : '') + '>Prev</button>';
    pageNumbers().forEach(function (p) {
      if (p === 'gap') { html += '<span class="gap">&hellip;</span>'; return; }
      html += '<button type="button" data-go="' + p + '"' + (p === cur ? ' class="on"' : '') + '>' + (p + 1) + '</button>';
    });
    html += '<button type="button" data-go="next"' + (cur === pages - 1 ? ' disabled' : '') + '>Next</button>';
    pager.innerHTML = html;
    if (scroll) {
      var top = document.getElementById('reviews').getBoundingClientRect().top + window.scrollY - 70;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  }

  pager.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-go]');
    if (!b || b.disabled) return;
    var g = b.getAttribute('data-go');
    if (g === 'prev') cur = Math.max(0, cur - 1);
    else if (g === 'next') cur = Math.min(pages - 1, cur + 1);
    else cur = parseInt(g, 10);
    render(true);
  });

  var rt = null;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () { render(false); }, 200);
  });

  render(false);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-sleep-selector"] && !Shopify.designMode) return;
  try {
    
(function(){
  var ORIGIN = 'https://mc-mattress-match.netlify.app';
  window.addEventListener('message', function(e){
    if (e.origin !== ORIGIN) return;
    var d = e.data || {};
    if (d.source !== 'mc-mattress-match') return;
    var frames = document.querySelectorAll('.mc-mm__frame');
    for (var i = 0; i < frames.length; i++){
      var f = frames[i];
      if (f.contentWindow !== e.source) continue;
      if (d.type === 'height' && d.height){
        f.style.height = d.height + 'px';
      } else if (d.type === 'scrollIntoView'){
        var rect = f.getBoundingClientRect();
        if (rect.top < 60 || rect.top > 160){
          window.scrollTo({ top: window.pageYOffset + rect.top - 90, behavior: 'smooth' });
        }
      }
    }
  }, false);
})();

  } catch(e) { console.error(e); }
})();
})();
